import { u as t, a as c, b as n, c as u } from "./chunk-SYFQ2XB5-BF5IDYrB.js";
const i = () => {
  const a = t(), s = c(), [e, o] = n(), r = u();
  return { location: a, navigate: s, params: r, searchParams: e, setSearchParams: o };
};
export {
  i as u
};
//# sourceMappingURL=useExposedProps-CetwhZpP.js.map
